import "./Deliverables.module.css";
import Navigation from "@/reusable_sections/Header";
import DevelopmentPathway from "./sections/DevelopmentPathway";
import WhatYouGet from "./sections/WhatYouGet";
import PremiumPortfolioShowcase from "./sections/PremiumPortfolioShowcase";
import Footer from "@/reusable_sections/Footer";
export default function DeliverablesPage() {
  return <div>
      <Navigation />
      <DevelopmentPathway />
      <PremiumPortfolioShowcase />
      <WhatYouGet />
      <Footer />
    </div>;
}